<template>
  <div class="main-layout-box">
    <left-menu></left-menu>
    <div class="main-layout-sub-box">
      <router-view/>
    </div>
  </div>
</template>

<script>
import LeftMenu from '@/views/components/LeftMenu';
export default {
  name: 'MainLayout',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
    LeftMenu,
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    this.status = this.$route.params.status;
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.main-layout-box {
  .main-layout-sub-box {
    padding: 20px;
    margin: 0 0 0 240px;
  }
  @media (max-width: 767px) {
    .main-layout-sub-box {
      margin: 0;
    }
  }
}
</style>
